import { api } from 'src/utils/auth';
import { getMemberInfo } from 'src/utils/common';
import { env } from 'src/env';

export const settlementDocuments = {
  income: '소득공제 신고',
  withholding: '원천징수 영수증',
  medical: '의료비 지급 영수증',
  donation: '기부금 명세서',
};
export type SettlementDocument = keyof typeof settlementDocuments;

const readError = async (data: any): Promise<string> => {
  try {
    const body = data instanceof Blob ? JSON.parse(await data.text()) : data;
    return body?.status?.message || '파일을 다운로드하지 못했습니다.';
  } catch {
    return '파일을 다운로드하지 못했습니다.';
  }
};

export const downloadSettlement = async (type: SettlementDocument) => {
  const member: any = getMemberInfo();
  try {
    const response = await api.post(
      `${env.REACT_APP_API_HOST}/api/settlement/download/${type}`,
      { acct_year: member.acct_year, co_cd: member.co_cd, co_id: member.co_id,
        ...(member.cust_cd ? { cust_cd: member.cust_cd } : {}) },
      { responseType: 'blob', timeout: 120000 }
    );
    const blob: Blob = response.data;
    if (blob.type.includes('json')) throw new Error(await readError(blob));
    if (!blob.size) throw new Error('다운로드할 파일이 없습니다.');

    const disposition = String(response.headers['content-disposition'] || '');
    const encoded = disposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i)?.[1];
    const plain = disposition.match(/filename\s*=\s*(?:"([^"]+)"|([^;]+))/i);
    let filename = plain?.[1] || plain?.[2]?.trim() || `${settlementDocuments[type]}.pdf`;
    if (encoded) {
      try { filename = decodeURIComponent(encoded.trim().replace(/^"|"$/g, '')); } catch { /* 기본 파일명 사용 */ }
    }
    filename = filename.replace(/[\\/]/g, '_');
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    try { link.click(); } finally {
      link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    }
  } catch (error: any) {
    if (error.response?.data) throw new Error(await readError(error.response.data));
    throw error;
  }
};
